// extracted by mini-css-extract-plugin
export default {"input_checkbox":"checkbox_input_checkbox__sFrEz"};